import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'
import _ from 'lodash'
import { HookUtils } from '@front/volcanion/utils'

import Callbacks from './callbacks'

const withContainer = Component => () => {
  const VOUCHER_ENABLED = hooks.useRelayFeature('VOUCHER_ENABLED')
  const user_id = hooks.useFormStateValue('user_id')
  const [{ isB2B, call_id, channel: domain_id }, setFormState] = hooks.useFormState()
  const isReady = hooks.useFormStatus('isReady')
  const setFormValues = hooks.useFormChange()
  const [load_type, companyservice_id, commercial_formula, customer_ref] = hooks.useFieldValues(['load_type', 'user.companyservice', 'user.commercial_formula', 'customer_ref'])
  const voucher_id = hooks.useFormStateValue('voucher_id')
  const [companyservice] = hooks.useModel('companyservice', [companyservice_id], { populate: ['customerref_option'], single: true })
  const [{ payment_types, payment_types_state }] = hooks.useAuthorizedPaymentTypes({
    service: companyservice_id, load_type, user_id, commercial_formula, domain_id
  }, isReady)
  const customerrefoption_id = _.get(companyservice, 'customerref_option.customerrefoption_id')
  const required = !isB2B || _.get(companyservice, 'customerref_option.fill_ref_rule') === 'required'
  const manual_allowed = !isB2B || _.get(companyservice, 'customerref_option.manual_allowed')
  const ids = _.map(payment_types, 'paymenttype_id')
  const order_doc_required = !!isB2B && companyservice?.fill_doc_rule === 'mandatory'

  const [customer_refs] = hooks.useModelSearch('customerref', 'get', {
    initial_filter: {},
    forced_filter: {
      client_id: { '!': null },
      parent: customerrefoption_id
    },
    validate_filter: useCallback(() => !!customerrefoption_id, [customerrefoption_id]),
    watchers: [customerrefoption_id]
  })

  const [, searchVoucher] = hooks.useModelSearch('voucher', 'get', { search_id: 'voucher_search', single: true, populate: ['companyservice'] })

  const customer_ref_options = _.uniqBy(_.flatten([
    _.map(customer_refs, ({ client_id }) => ({ label: client_id, value: client_id })),
    { label: customer_ref, value: customer_ref },
  ]), 'value')

  const afterVoucherChange = useCallback(Callbacks.afterVoucherChangeHandler(setFormValues, setFormState, searchVoucher, isB2B), [setFormValues, setFormState, searchVoucher, isB2B])
  const validateVoucher = useCallback(Callbacks.validateVoucherHandler(voucher_id), [voucher_id])

  const mergedProps = {
    isLoading: HookUtils.getLoadingState([payment_types_state]),
    manual_allowed,
    required,
    order_doc_required,
    call_id,
    isB2B,
    ids,
    customer_ref_options,
    VOUCHER_ENABLED,
    afterVoucherChange,
    validateVoucher
  }
  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
